import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import { applyTheme, readTheme } from "@/lib/theme";

import Landing from "@/pages/Landing";
import Features from "@/pages/Features";
import Publications from "@/pages/Publications";
import AboutPublic from "@/pages/AboutPublic";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import ContactPublic from "@/pages/ContactPublic";
import GalleryPublic from "@/pages/GalleryPublic";
import CodePublic from "@/pages/CodePublic";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import DashboardApp from "@/pages/DashboardApp";

export default function App() {
  useEffect(() => { applyTheme(readTheme()); }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/features" element={<Features />} />
          <Route path="/publications" element={<Publications />} />
          <Route path="/about" element={<AboutPublic />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/gallery" element={<GalleryPublic />} />
          <Route path="/code" element={<CodePublic />} />
          <Route path="/contact" element={<ContactPublic />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/app" element={<ProtectedRoute><DashboardApp /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}
